import { Box, TableCell, TableRow, useMediaQuery, useTheme } from '@mui/material';
import { FunctionComponent } from 'react';
import { L3ServiceViewModel } from '../../model';
import { L3ServiceNotificationsButton } from '../L3ServiceNotificationsButton/L3ServiceNotificationsButton';
import { L3ServicePreference } from '../L3ServicePreference/L3ServicePreference';
import { L3ServiceStatusIcon } from '../L3ServiceStatusIcon/L3ServiceStatusIcon';
import { useAppTranslate } from '../../../core/hooks';

interface Props {
  l3Service: L3ServiceViewModel;
}

export const L3ServiceMobile: FunctionComponent<Props> = ({ l3Service }) => {
  const translate = useAppTranslate();
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  return <TableRow>
    <TableCell sx={{ p: 1 }} colSpan={4}>
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        border: '1px #fff solid',
        borderRadius: 2,
        width: 1,
        my: 1,
        p: 1,
        backgroundColor: '#fff',
        boxShadow: 1,
      }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: 1 }}>
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ mr: 2 }}>
              <L3ServiceStatusIcon l3Service={l3Service} />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Box>{l3Service.name}</Box>
              <Box>{l3Service.address}</Box>
            </Box>
          </Box>
          <Box sx={{ display: 'flex' }}>
            <L3ServicePreference l3Service={l3Service} />
          </Box>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <L3ServiceNotificationsButton l3Service={l3Service} />
          <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            {isTablet &&
              <Box sx={{ color: '#6E7C87' }}>
                <span style={{ display: 'inline-block'}}>{l3Service.throughputFormatted}</span>
                {l3Service.device !== undefined &&
                <>
                  <span style={{ display: 'inline-block'}}>&nbsp;|&nbsp;</span>
                  <span style={{ display: 'inline-block'}}>{translate('device')}: {l3Service.device?.type}</span>
                </>}
              </Box>}
            <Box>{translate('tableHeaders.soz')}: {l3Service.orderNumber}</Box>
          </Box>
        </Box>
      </Box>
    </TableCell>
  </TableRow>;
};